import React, { useState, useRef, Fragment } from "react";
import Config from "../../Config";

import back from "../../back.png";
import InputDate from "../../helpers/InputDate";
import InputText from "../../helpers/InputText";
import InputCombo from "../../helpers/InputCombo";
import InputDecimal from "../../helpers/InputDecimal";
import InputComboStawkiWyzMulti from "../../helpers/InputComboStawkiWyzMulti";
import InputComboStawkiWyz from "../../helpers/InputComboStawkiWyz";
import InputComboStawki from "../../helpers/InputComboStawki";



function InvoiceKorMass(props)
{ 

    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [row, setRow] = useState({
    
        ids: props.ids,
        ilosc_edytowanych: 1,

        powod_korekty: '',
        

        //pozycja pierwsza..
        fraza: '',
        p_typy_oplat_id: '_x_',

        operacja: '_x_',
        wartosc: 0.00,

        ilosc: 0.00,
        jm: 'sztuki',
        typ_wlasny: 'Inne',


        //pozycja druga..
 
        fraza_2: '',
        p_typy_oplat_id_2: '_x_',
     
        operacja_2: '_x_',
        wartosc_2: 0.00,
     
        ilosc_2: 0.00,
        jm_2: 'sztuki',
        typ_wlasny_2: 'Inne',


        //pozycja trzecia..
 
        fraza_3: '',
        p_typy_oplat_id_3: '_x_',
     
        operacja_3: '_x_',
        wartosc_3: 0.00,
     
        ilosc_3: 0.00,
        jm_3: 'sztuki',
        typ_wlasny_3: 'Inne',        
        
    });


    const [invoices, setInvoices] = useState([]);

    
    const valChangeListener = (filedName, val, correct, msg) => { 
      //   console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);         
         setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct  } );         

         if(filedName == 'p_typy_oplat_id' || filedName == 'fraza' || filedName == 'operacja' )
         {
              //  var newRow = JSON.parse( JSON.stringify(row) );
              //  newRow[filedName] = val;
              //  checkP(newRow);
         }


     }
 
 
  
 
 
     const goNextNew = () => {
         console.log("goNext");
         saveData();
     }


    const onBack = (e) => {
        props.goBack();
    }


    
    

    const saveData = (e) => {

  
        props.mainView.setProgress(-2);


    
        fetch( Config.url + '/rest_v1_calc,create_correct_mass', {
            method: 'POST', 
            body: JSON.stringify(row), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })         
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        props.mainView.setProgress(-1);  
                        if(res.status == 'OK') {
                                props.mainView.showDialog( "Sukces", 'Dane zostały zapisane', "ok" , null); 
                                props.goBack();
                           
                        }
                        if(res.status == 'ERROR') {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);   
                        }

                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });

    }

    


    const itemsOperacja = [    

        { v: '_x_',   title: 'Nie rób nic' },  
        //{ v: 'delete',   title: 'Usuń pozycje z dokumentu' },  

        { v: 'plus_ilosc',   title: 'Zwiększ (+) ILOŚĆ o podaną wartość:' },        
        { v: 'minus_ilosc',  title: 'Zmniejsz (-) ILOŚĆ o podaną wartość:' },                        
        { v: 'set_ilosc',  title: 'Ustaw ILOŚĆ na:' },     

        { v: 'plus_cena',   title: 'Zwiększ (+) CENĘ o podaną wartość:' },        
        { v: 'minus_cena',  title: 'Zmniejsz (-) CENĘ o podaną wartość:' },                        
        { v: 'set_cena',  title: 'Ustaw CENĘ na:' },   
    ]; 



    const itemsOperacja2 = [    

        { v: '_x_',   title: 'Nie rób nic' },  
      //  { v: 'new_item',  title: 'Dodaj jako nową pozycje (+)' },   
     //   { v: 'delete',   title: 'Usuń pozycje z dokumentu' },   

        { v: 'plus_ilosc',   title: 'Zwiększ (+) ILOŚĆ o podaną wartość:' },        
        { v: 'minus_ilosc',  title: 'Zmniejsz (-) ILOŚĆ o podaną wartość:' },                        
        { v: 'set_ilosc',  title: 'Ustaw ILOŚĆ na:' },     

        { v: 'plus_cena',   title: 'Zwiększ (+) CENĘ o podaną wartość:' },        
        { v: 'minus_cena',  title: 'Zmniejsz (-) CENĘ o podaną wartość:' },                        
        { v: 'set_cena',  title: 'Ustaw CENĘ na:' },   
    ]; 



    
    const itemsJM = [    
        { v: 'godzina', title: 'Godzina' },        
        { v: 'dzień',   title: 'Dzień' },         
        { v: 'sztuki',  title: 'Sztuki' },         
        { v: 'miesiąc', title: 'Miesiąc' },         
    ]; 


    const itemsTyp = [    
        { v: 'Czesne', title: 'Czesne' },        
        { v: 'Wyżywienie',   title: 'Wyżywienie' },         
        { v: 'Inne',  title: 'Inne' },                 
    ]; 

    const itemsEdytowanych = [    
        { v: 1, title: 'Jedna pozycja' },        
        { v: 2,   title: 'Dwie pozycje' },         
        { v: 3,  title: 'Trzy pozycje' },                 
    ]; 


    //console.log("Pozycje", row);


        return <div className="view_content">

                    <img src={back} onClick={onBack} className="back_img" title="wstecz"/>

                    <h1> Korekta masowa (wystaw korekty do edycji i zatwierdzenia) </h1>

                    <div className="form_tab_title red_cg">Wybrano dokumentów do edycji: ({props.ids.length}) </div>    

                    <form className="eForm bg_center">


                    <div className="form_tab">
                                <div className="form_control"> 
                                           <div className="fieldName">Ilość edytowanych pozycji</div>                                                       
                                        <InputCombo items={itemsEdytowanych} value={row.ilosc_edytowanych} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"ilosc_edytowanych"} placeholder={""} className='' req='0'   />  
                                </div>

                                <div className="form_control"> 
                                           <div className="fieldName">Powód korekty</div>                                                       
                                        <InputText  value={row.powod_korekty} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"powod_korekty"} placeholder={""} className='w400' req='0'   />  
                                </div>
                    </div>
                     

                         
                            <div className="form_tab">
                                    <div className="form_tab_title">1. </div>
                              

                                    <div className="form_control filedset_inline">
                                                                                                                                                                                                   
                                                        <InputComboStawki  mainView={props.mainView}  userData={props.userData} value={row.p_typy_oplat_id} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="p_typy_oplat_id" placeholder={""} className='w300' req='0'    />
                                                        <b>lub </b>
                                                        **<InputText   userData={props.userData} value={row.fraza} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="fraza" placeholder={"**Fraza: "} className='w300' req='0'   />                                                                                                                                                  
                                    </div>

                                    <div className="form_split"></div>                                     
                                    {
                                        row.p_typy_oplat_id  == '_x_' &&
                                            <div className="form_control"> 
                                                            <div className="fieldName">Operacja</div>                                                       
                                                            <InputCombo items={itemsOperacja} value={row.operacja} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"operacja"} placeholder={""} className='' req='0'   />  
                                            </div>
                                    }  

                                    {
                                        row.p_typy_oplat_id  != '_x_' &&
                                            <div className="form_control"> 
                                                            <div className="fieldName">Operacja</div>                                                       
                                                            <InputCombo items={itemsOperacja2} value={row.operacja} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"operacja"} placeholder={""} className='' req='0'   />  
                                            </div>
                                    }

                                    {
                                        (row.operacja == "plus_ilosc" || row.operacja == "minus_ilosc" || row.operacja == "set_ilosc" || row.operacja == "plus_cena" || row.operacja == "minus_cena" || row.operacja == "set_cena" ) &&
                                            <div className="form_control">
                                                        <div className="fieldName">Wartość</div>
                                                        <InputDecimal   userData={props.userData} value={row.wartosc} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="wartosc" placeholder={""} className='' req='0'   />
                                            </div>
                                    }

                                    {
                                        (row.operacja == "new_item"   ) &&
                                        <Fragment>

                                                <div className="form_control"> 
                                                          <div className="fieldName">Rodzaj</div>                                                       
                                                         <InputCombo items={itemsTyp} value={row.typ_wlasny} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"typ_wlasny"} placeholder={""} className='  ' req='0'   />  
                                                </div>

                                                <div className="form_control">
                                                            <div className="fieldName">Ilość</div>
                                                            <InputDecimal   userData={props.userData} value={row.ilosc} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="ilosc" placeholder={""} className='' req='0'   />
                                                </div>

                                                <div className="form_control"> 
                                                            <div className="fieldName">JM</div>                                                       
                                                            <InputCombo items={itemsJM} value={row.jm} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"jm"} placeholder={""} className='  ' req='0'   />  
                                                </div>
                                        </Fragment>                                           
                                    }
                          
                            </div>


                            <br/>&nbsp;<br/>
                            {
                                row.ilosc_edytowanych > 1 &&

                                                <div className="form_tab">
                                                     <div className="form_tab_title">2.</div>
                                            

                                                <div className="form_control filedset_inline">
                                                                                                                                                                                                            
                                                                    <InputComboStawki  mainView={props.mainView}  userData={props.userData} value={row.p_typy_oplat_id_2} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="p_typy_oplat_id_2" placeholder={""} className='w300' req='0'   />
                                                                    <b>lub </b>
                                                                    **<InputText   userData={props.userData} value={row.fraza_2} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="fraza_2" placeholder={"**Fraza: "} className='w300' req='0'   />                                                                                                                                                  
                                                </div>

                                                <div className="form_split"></div>                                     
                                                {
                                                    row.p_typy_oplat_id_2  == '_x_' &&
                                                        <div className="form_control"> 
                                                                        <div className="fieldName">Operacja</div>                                                       
                                                                        <InputCombo items={itemsOperacja} value={row.operacja_2} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"operacja_2"} placeholder={""} className='' req='0'   />  
                                                        </div>
                                                }  

                                                {
                                                    row.p_typy_oplat_id_2  != '_x_' &&
                                                        <div className="form_control"> 
                                                                        <div className="fieldName">Operacja</div>                                                       
                                                                        <InputCombo items={itemsOperacja2} value={row.operacja_2} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"operacja_2"} placeholder={""} className='' req='0'   />  
                                                        </div>
                                                }

                                                {
                                                    (row.operacja_2 == "plus_ilosc" || row.operacja_2 == "minus_ilosc" || row.operacja_2 == "set_ilosc" || row.operacja_2 == "plus_cena" || row.operacja_2 == "minus_cena" || row.operacja_2 == "set_cena" ) &&
                                                        <div className="form_control">
                                                                    <div className="fieldName">Wartość</div>
                                                                    <InputDecimal   userData={props.userData} value={row.wartosc_2} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="wartosc_2" placeholder={""} className='' req='0'   />
                                                        </div>
                                                }

                                                {
                                                    (row.operacja_2 == "new_item"   ) &&
                                                    <Fragment>

                                                            <div className="form_control"> 
                                                                    <div className="fieldName">Rodzaj</div>                                                       
                                                                    <InputCombo items={itemsTyp} value={row.typ_wlasny_2} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"typ_wlasny_2"} placeholder={""} className='  ' req='0'   />  
                                                            </div>

                                                            <div className="form_control">
                                                                        <div className="fieldName">Ilość</div>
                                                                        <InputDecimal   userData={props.userData} value={row.ilosc_2} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="ilosc_2" placeholder={""} className='' req='0'   />
                                                            </div>

                                                            <div className="form_control"> 
                                                                        <div className="fieldName">JM</div>                                                       
                                                                        <InputCombo items={itemsJM} value={row.jm_2} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"jm_2"} placeholder={""} className='  ' req='0'   />  
                                                            </div>
                                                    </Fragment>                                           
                                                }

                                        </div>
                            }

                            <br/>&nbsp;<br/>     


                            {
                                row.ilosc_edytowanych > 2 &&

                                                <div className="form_tab">

                                                <div className="form_tab_title">3.</div>
                                            

                                                <div className="form_control filedset_inline">
                                                                                                                                                                                                            
                                                                    <InputComboStawki  mainView={props.mainView}  userData={props.userData} value={row.p_typy_oplat_id_3} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="p_typy_oplat_id_3" placeholder={""} className='w300' req='0'   />
                                                                    <b>lub </b>
                                                                    **<InputText   userData={props.userData} value={row.fraza_3} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="fraza_3" placeholder={"**Fraza: "} className='w300' req='0'   />                                                                                                                                                  
                                                </div>

                                                <div className="form_split"></div>                                     
                                                {
                                                    row.p_typy_oplat_id_3  == '_x_' &&
                                                        <div className="form_control"> 
                                                                        <div className="fieldName">Operacja</div>                                                       
                                                                        <InputCombo items={itemsOperacja} value={row.operacja_3} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"operacja_3"} placeholder={""} className='' req='0'   />  
                                                        </div>
                                                }  

                                                {
                                                    row.p_typy_oplat_id_3  != '_x_' &&
                                                        <div className="form_control"> 
                                                                        <div className="fieldName">Operacja</div>                                                       
                                                                        <InputCombo items={itemsOperacja} value={row.operacja_3} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"operacja_3"} placeholder={""} className='' req='0'   />  
                                                        </div>
                                                }

                                                {
                                                    (row.operacja_3 == "plus_ilosc" || row.operacja_3 == "minus_ilosc" || row.operacja_3 == "set_ilosc" || row.operacja_3 == "plus_cena" || row.operacja_3 == "minus_cena" || row.operacja_3 == "set_cena" ) &&
                                                        <div className="form_control">
                                                                    <div className="fieldName">Wartość</div>
                                                                    <InputDecimal   userData={props.userData} value={row.wartosc_3} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="wartosc_3" placeholder={""} className='' req='0'   />
                                                        </div>
                                                }

                                                {
                                                    (row.operacja_3 == "new_item"   ) &&
                                                    <Fragment>

                                                            <div className="form_control"> 
                                                                    <div className="fieldName">Rodzaj</div>                                                       
                                                                    <InputCombo items={itemsTyp} value={row.typ_wlasny_3} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"typ_wlasny_3"} placeholder={""} className='  ' req='0'   />  
                                                            </div>

                                                            <div className="form_control">
                                                                        <div className="fieldName">Ilość</div>
                                                                        <InputDecimal   userData={props.userData} value={row.ilosc_3} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="ilosc_3" placeholder={""} className='' req='0'   />
                                                            </div>

                                                            <div className="form_control"> 
                                                                        <div className="fieldName">JM</div>                                                       
                                                                        <InputCombo items={itemsJM} value={row.jm_3} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"jm_3"} placeholder={""} className='  ' req='0'   />  
                                                            </div>
                                                    </Fragment>                                           
                                                }

                                        </div>
                            }




                     
 

                            <div className="form_btn">

                                    <div className="btn" onClick={saveData}>Wystaw korekty</div>
                                     &nbsp;
                                    <div className="btn" onClick={onBack}>Wstecz</div>

                            </div>


                    </form>
            
        </div>
}

export default InvoiceKorMass;

